import { Building, BarChart3, FileCheck, Network } from "lucide-react";

const focusAreas = [
  {
    icon: Building,
    title: "Investment Structuring & Governance",
    description:
      "Understand the architecture of institutional-grade investment vehicles, including fund structures, governance frameworks, and operational models. Learn how to align investment strategies with regulatory compliance and investor protection standards.",
  },
  {
    icon: BarChart3,
    title: "Capital Market Readiness",
    description:
      "Explore the prerequisites for participating in capital raising and deployment activities. Gain insights into investor documentation, due diligence processes, and the operational requirements of capital market intermediaries.",
  },
  {
    icon: FileCheck,
    title: "Compliance & Investor Servicing",
    description:
      "Master the compliance landscape including KYC/AML requirements, regulatory reporting, and investor communication protocols. Learn best practices for maintaining transparent and accountable relationships with investors.",
  },
  {
    icon: Network,
    title: "Scalable Capital Frameworks",
    description:
      "Discover how to build scalable systems for capital aggregation, investor onboarding, and fund execution. Understand the technology, processes, and partnerships required to operate at institutional scale.",
  },
];

export default function KeyFocusAreas() {
  return (
    <section
      className="relative min-h-screen px-6 md:px-12 lg:px-24
      bg-gradient-to-b from-[#F8FAFC] via-white to-[#F1F5F9]
      flex items-center overflow-hidden"
    >
      {/* subtle brand glow */}
      <div className="absolute inset-x-0 top-1/3 h-[420px] bg-[#0E6F7E]/5 blur-3xl"></div>

      <div className="container mx-auto max-w-7xl relative z-10">
        {/* Heading */}
        <div className="text-center mb-14">
          <div className="h-1 w-16 bg-gradient-to-r from-[#D4AF37] to-[#C9A631] mx-auto mb-6"></div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#07162E] mb-4">
            Key Focus Areas
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Deep dive into the critical domains that define institutional-grade
            capital management
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {focusAreas.map((area, index) => (
            <div
              key={index}
              className="group bg-white/80 backdrop-blur-xl
              rounded-2xl p-8
              shadow-[0_20px_50px_rgba(2,8,23,0.08)]
              hover:shadow-[0_30px_70px_rgba(2,8,23,0.15)]
              transition-all duration-300 transform hover:-translate-y-2
              border-t-4 border-[#0E6F7E]"
            >
              <div className="flex items-start gap-5">
                {/* Icon */}
                <div
                  className="flex-shrink-0 w-14 h-14 rounded-xl
                  bg-gradient-to-br from-[#07162E] via-[#0B2A4A] to-[#0E6F7E]
                  flex items-center justify-center
                  group-hover:scale-110 group-hover:rotate-3
                  transition-all duration-300"
                >
                  <area.icon className="w-7 h-7 text-[#1DBF73]" />
                </div>

                {/* Content */}
                <div>
                  <h3 className="text-xl font-bold text-[#07162E] mb-3">
                    {area.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                    {area.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
